<template>
  <div
    class="rs-listing__results"
    :lang="selectedLanguage"
    :dir="selectedLanguageDirection"
  >
    <!-- <div v-if="fetchedResults.posts" class="rs-listing__results__showing">
      Showing {{ fetchedResults.posts.length }} of {{ fetchedResults.total_posts }}
    </div> -->
    <div class="rs-listing__results__grid">
      <RSFestivalListingCard
        v-for="(post, i) in fetchedResults.posts"
        :key="post.ID"
        :post="post"
        :baseURL="baseURL"
        ref="card"
        @hook:mounted="
          i == fetchedResults.posts.length - 1 && onBottomCardMounted()
        "
        @scroll-to-top-request="$emit('scroll-to-top-request')"
      />
    </div>
  </div>
</template>

<script>
import RSFestivalListingCard from "./RSFestivalListingCard.vue";
export default {
  name: "RSResults",
  components: {
    RSFestivalListingCard,
  },
  props: {
    baseURL: String,
    fetchedResults: Object,
    selectedLanguage: String,
  },
  methods: {
    onBottomCardMounted() {
      if (this.$refs.card && this.$refs.card.length) {
        let bottomCardVueComponent =
          this.$refs.card[this.$refs.card.length - 1];
        this.$emit("bottom-card-change", bottomCardVueComponent);
      }
    },
  },
  computed: {
    selectedLanguageDirection() {
      if (this.selectedLanguage === "he") return "rtl";
      else return "ltr";
    },
  },
};
</script>

